<template>
  <div class="shop-reviews page-media">
    <template v-if="reviews.length > 0">
      <SfProductCardHorizontal
        v-for="(media, i) in reviews"
        :key="media.id"
        :style="{ '--index': i, 'background-image': `url(${getImage(media.image)})` }"
        :title="media.name"
        :link="{ name: 'instruction-page', params: { id: media.id } }"
        :description="media.short_description"
        :image="getImage(media.image)"
        wishlistIcon=""
        isOnWishlistIcon=""
        class="products__product-card-horizontal"
      >
        <template #add-to-cart>
          <div class="date">
            <span>{{ date(media.created_at) }}</span>
          </div>
        </template>
      </SfProductCardHorizontal>
    </template>
    <template v-else>
      Нет данных
    </template>
  </div>
</template>

<script>
import apiRequest from '../../shared/apiRequest'

import moment from 'moment'

import { SfProductCardHorizontal } from '@storefront-ui/vue'

export default {
  props: {
    account: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    SfProductCardHorizontal
  },
  data() {
    return {
      reviews: [],
      review: null
    }
  },

  mounted() {
    this.getReviews()
  },
  methods: {
    getReviews() {
      apiRequest.get(`/instructions`)
        .then(({ data }) => {
          this.reviews = data.data
        })
    },
    getImage(image) {
      const imageCont = image.split('.');
      return `${process.env.VUE_APP_STORAGE}/${imageCont[0]}-medium.${imageCont[1]}`
    },
    getDefaultImage(image) {
      return `${process.env.VUE_APP_STORAGE}/${image}`
    },
    date(created_at) {
      return moment(created_at).format('YYYY.MM.DD')
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@storefront-ui/vue/styles";
#category {
  box-sizing: border-box;
  @include for-desktop {
    max-width: 1240px;
    margin: 0 auto;
  }
}
.main {
  &.section {
    padding: var(--spacer-xs);
    @include for-desktop {
      padding: 0;
    }
  }
}
.breadcrumbs {
  padding: var(--spacer-base) var(--spacer-base) var(--spacer-base)
    var(--spacer-sm);
}
.navbar {
  position: relative;
  display: flex;
  border: 1px solid var(--c-light);
  border-width: 0 0 1px 0;
  @include for-desktop {
    border-width: 1px 0 1px 0;
  }
  &.section {
    padding: var(--spacer-sm);
    @include for-desktop {
      padding: 0;
    }
  }
  &__aside,
  &__main {
    display: flex;
    align-items: center;
    padding: var(--spacer-sm) 0;
  }
  &__aside {
    flex: 0 0 15%;
    padding: var(--spacer-sm) var(--spacer-sm);
    border: 1px solid var(--c-light);
    border-width: 0 1px 0 0;
  }
  &__main {
    flex: 1;
    display: flex;
    padding: 0;
    @include for-desktop {
      padding: var(--spacer-xs) var(--spacer-xl);
    }
  }
  &__title {
    --heading-title-font-weight: var(--font-weight--semibold);
    --heading-title-font-size: var(--font-size--xl);
  }
  &__filters-icon {
    margin: 0 0 0 var(--spacer-2xs);
    order: 1;
    @include for-desktop {
      margin: 0 var(--spacer-xs) 0 0;
      order: 0;
    }
  }
  &__filters-button {
    display: flex;
    align-items: center;
    --button-font-size: var(--font-size--base);
    --button-text-decoration: none;
    --button-color: var(--c-link);
    --button-font-weight: var(--font-weight--normal);
    @include for-mobile {
      --button-font-weight: var(--font-weight--medium);
      margin-right: var(--spacer-sm);
      order: 1;
    }
    svg {
      fill: var(--c-text-muted);
      transition: fill 150ms ease;
    }
    &:hover {
      svg {
        fill: var(--c-primary);
      }
    }
  }
  &__label {
    font-family: var(--font-family--secondary);
    font-weight: var(--font-weight--normal);
    color: var(--c-text-muted);
    @include for-desktop {
      margin: 0 var(--spacer-2xs) 0 0;
    }
  }
  &__select {
    --component-select-width: 220px;
    --component-select-padding: 0;
    --component-select-selected-padding: 0 var(--spacer-lg) 0 var(--spacer-2xs);
    --component-select-margin: 0;
    --component-select-error-message-height: 0;
  }
  &__sort {
    display: flex;
    align-items: center;
    margin: 0 auto 0 var(--spacer-2xl);
  }
  &__counter {
    font-family: var(--font-family--secondary);
    margin: auto;
    @include for-desktop {
      margin: auto 0 auto auto;
    }
  }
  &__view {
    display: flex;
    order: -1;
    align-items: center;
    margin: 0;
    @include for-desktop {
      margin: 0 0 0 var(--spacer-2xl);
      order: 0;
    }
    &-icon {
      cursor: pointer;
      margin: 0 var(--spacer-base) 0 var(--spacer-sm);
      @include for-desktop {
        margin: 0 var(--spacer-base) 0 0;
      }
      &:last-child {
        margin: 0;
      }
    }
    &-label {
      margin: 0 var(--spacer-sm) 0 0;
      font: var(--font-weight--normal) var(--font-size--base) / 1.6
        var(--font-family--secondary);
      text-decoration: none;
      color: var(--c-link);
    }
  }
}
.sort-by {
  --component-select-dropdown-z-index: 1;
  flex: unset;
  width: 11.875rem;
}
.main {
  display: flex;
}
.sidebar {
  flex: 0 0 30%;
  padding: var(--spacer-sm);
  border: 1px solid var(--c-light);
  border-width: 0 0 0 1px;
}
.sidebar-filters {
  --sidebar-title-display: none;
  --sidebar-top-padding: 0;
  @include for-desktop {
    --sidebar-content-padding: 0 var(--spacer-xl);
    --sidebar-bottom-padding: 0 var(--spacer-xl);
  }
}
.list {
  --menu-item-font-size: var(--font-size--sm);
  &__item {
    &:not(:last-of-type) {
      --list-item-margin: 0 0 var(--spacer-sm) 0;
    }
  }
}
.products {
  box-sizing: border-box;
  flex: 1;
  margin: 0;
  width: 100%;
  &__grid,
  &__list {
    display: flex;
    flex-wrap: wrap;
    &--view {
      font: var(--header-navigation-item-font, 
        var(--header-navigation-item-font-weight, 
        var(--font-weight--normal)) var(--header-navigation-item-font-size, 
        var(--font-size--base))/var(--header-navigation-item-font-line-height, 1.2) var(--header-navigation-item-font-family, 
        var(--font-family--secondary)));
    }
  }
  &__grid {
    justify-content: center;
    @include for-desktop {
      justify-content: space-between;
    }
  }
  &__product-card {
    --product-card-max-width: 11rem;
    --product-card-title-margin: var(--spacer-2xs) 0 0 0;
    --price-regular-font-line-height: 1;
    margin-bottom: var(--spacer-sm);
    ::v-deep .sf-product-card__image {
      height: 12.9375rem;
    }
    ::v-deep .sf-product-card__price {
      margin: var(--spacer-2xs) 0 var(--spacer-xs);
    }
    flex: 1 1 50%;
    @include for-desktop {
      margin-bottom: 0;
      --product-card-max-width: 50%;
      --product-card-title-margin: var(--spacer-base) 0 0 0;
      ::v-deep .sf-product-card__image {
        height: unset;
      }
    }
  }
  &__product-card-horizontal {
    margin-bottom: var(--spacer-sm);
    flex: 0 0 100%;
    ::v-deep .sf-product-card-horizontal__wishlist-icon {
      .sf-icon {
        width: 1.5rem;
        height: 1.5rem;
      }
    }
  }
  &__slide-enter {
    opacity: 0;
    transform: scale(0.5);
  }
  &__slide-enter-active {
    transition: all 0.2s ease;
    transition-delay: calc(0.1s * var(--index));
  }
  &__pagination {
    display: flex;
    justify-content: center;
    margin: var(--spacer-base) 0;
  }
  @include for-desktop {
    margin: var(--spacer-sm) 0 0 var(--spacer-sm);
    &__pagination {
      justify-content: flex-start;
      margin: var(--spacer-xl) 0 0 0;
    }
    &__product-card-horizontal {
      margin: var(--spacer-lg) 0;
    }
    &__product-card {
      flex: 1 1 25%;
    }
    &__list {
      margin: 0 0 0 var(--spacer-sm);
    }
  }
  &__show-on-page {
    display: flex;
    justify-content: flex-end;
    align-items: baseline;
    &__label {
      font-family: var(--font-family--secondary);
      font-size: var(--font-size--sm);
    }
  }
}
.filters {
  &__title {
    --heading-title-font-size: var(--font-size--xl);
    margin: var(--spacer-xl) 0 var(--spacer-base) 0;
    &:first-child {
      margin: calc(var(--spacer-xl) + var(--spacer-base)) 0 var(--spacer-xs) 0;
    }
  }
  &__colors {
    display: flex;
  }
  &__color {
    margin: var(--spacer-xs) var(--spacer-xs) var(--spacer-xs) 0;
  }
  &__chosen {
    color: var(--c-text-muted);
    font-weight: var(--font-weight--normal);
    font-family: var(--font-family--secondary);
    position: absolute;
    right: var(--spacer-xl);
  }
  &__item {
    --radio-container-padding: 0 var(--spacer-sm) 0 var(--spacer-xl);
    --radio-background: transparent;
    --filter-label-color: var(--c-secondary-variant);
    --filter-count-color: var(--c-secondary-variant);
    --checkbox-padding: 0 var(--spacer-sm) 0 var(--spacer-xl);
    padding: var(--spacer-sm) 0;
    border-bottom: 1px solid var(--c-light);
    &:last-child {
      border-bottom: 0;
    }
    @include for-desktop {
      --checkbox-padding: 0;
      margin: var(--spacer-sm) 0;
      border: 0;
      padding: 0;
    }
  }
  &__accordion-item {
    --accordion-item-content-padding: 0;
    position: relative;
    left: 50%;
    right: 50%;
    margin-left: -50vw;
    margin-right: -50vw;
    width: 100vw;
  }
  &__buttons {
    margin: var(--spacer-sm) 0;
  }
  &__button-clear {
    --button-background: var(--c-light);
    --button-color: var(--c-dark-variant);
    margin: var(--spacer-xs) 0 0 0;
  }
}
</style>

<style lang="scss">
.page-media {
  .main {
    flex-direction: column;
    align-items: flex-start;
    @include for-desktop {
      flex-direction: row;
    }
  }
  .sf-product-card-horizontal__actions-wrapper {
    flex: 1 25%;
  } 
  .sf-product-card-horizontal__add-to-cart {
    white-space: nowrap;
  }
  .sidebar.desktop-only {
    position: sticky;
    top: 100px;
    max-width: 340px;
  }
  .product {
    h3 {
      font-size: 16px;
      line-height: 18px;
      margin: 8px 0;
    }
  }

  .sidebar-mobile {
    margin-bottom: 60px;
  }

  .products__product-card-horizontal {
    background-size: cover;
    background-position: center;
    @media all and (max-width: 767px) {
      height: calc(100vh - 200px);
      color: #fff !important;
      fill: #fff;
      border-radius: 20px;

      a, h3 {
        color: #fff !important;
        text-shadow: -1px 2px 8px black;
      }

      .sf-product-card-horizontal__image-wrapper {
        display: none;
      }

      .sf-product-card-horizontal__add-to-cart {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 15px;
        text-shadow: -1px 2px 8px black;
      }

      .sf-product-card-horizontal__details {
        height: 100%;
        flex: auto;
        justify-content: flex-end;
      }

      .sf-product-card-horizontal__actions-wrapper {
        flex: auto;
      }

      button {
        display: none;
      }
    }
    @include for-desktop {
      background-image: none !important;

      .sf-product-card-horizontal__add-to-cart {
        height: 100%;
        justify-content: space-between;
        flex-direction: column-reverse;
        display: flex;
        align-items: flex-end;
      }

      .sf-product-card-horizontal__actions {
        display: none;
      }
    }
  }
}
.ambassodor {
  margin: 15px 0;
  img {
    width: 100%;
  }
}

</style>